import * as XLSX from 'xlsx';

/**
 * Export an array of plain-object rows to an .xlsx file download.
 * Columns are derived from the first row unless `columns` is supplied.
 *
 * @param {Array<object>} rows
 * @param {object} [opts]
 * @param {string} [opts.filename='export.xlsx']
 * @param {string} [opts.sheetName='Sheet1']
 * @param {Array<{key:string,label:string}>} [opts.columns]
 */
export function exportToExcel(rows, opts = {}) {
  const { filename = 'export.xlsx', sheetName = 'Sheet1', columns } = opts;

  const data = columns
    ? rows.map((r) =>
        columns.reduce((acc, c) => {
          acc[c.label] = r[c.key];
          return acc;
        }, {}),
      )
    : rows;

  const sheet = XLSX.utils.json_to_sheet(data);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, sheetName.slice(0, 31));
  XLSX.writeFile(book, filename);
}
